import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnMount from './components/ScrollToTopOnMount';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import GalleryPage from './pages/Gallery';
import About from './pages/About';
import CoreServices from './pages/CoreServices';
import OtherServicesPage from './pages/OtherServicesPage';
import Teleconsultation from './pages/Teleconsultation';
import CapacityBuilding from './pages/CapacityBuilding';
import JobVacancy from './pages/JobVacancy';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTopOnMount />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/core-services" element={<CoreServices />} />
          <Route path="/other-services" element={<OtherServicesPage />} />
          <Route path="/teleconsultation" element={<Teleconsultation />} />
          <Route path="/capacity-building" element={<CapacityBuilding />} />
          <Route path="/job-vacancy" element={<JobVacancy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
        <Footer />
        <ScrollToTop />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
